import { Box, IconButton, TextField } from '@mui/material';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import { useContext } from 'react';
import { ThemeContext } from '../../../../context/ThemeContext';

const TPInput = ({ takeProfit, setTakeProfit, tpValidation, symbolData, side }) => {
    const { darkMode } = useContext(ThemeContext)
    const handleChange = (value) => {
        if (value === '') {
            setTakeProfit('');
            return;
        }

        const decimals = value.split('.')?.[1];
        if (!decimals || decimals.length <= symbolData.digits) {
            setTakeProfit(value);
        }
    };


    const handleStepChange = (isIncrease) => {
        let currentValue = parseFloat(takeProfit);
        if (isNaN(currentValue)) currentValue = parseFloat(tpValidation);

        const step = 1 / Math.pow(10, symbolData?.digits || 2);
        const newValue = isIncrease ? currentValue + step : currentValue - step;
        const finalValue = Math.max(0, parseFloat(newValue.toFixed(symbolData?.digits)));

        setTakeProfit(finalValue.toFixed(symbolData?.digits));
    };

    const handleBlur = (e) => {
        const value = parseFloat(e.target.value);
        if (isNaN(value)) return;

        const minTP = parseFloat(tpValidation);
        let finalValue;

        if (side === 1) {
            finalValue = minTP < value ? value : minTP;
        } else {
            finalValue =  minTP > value ? value : minTP;
        }

        setTakeProfit(finalValue.toFixed(symbolData.digits));
    };
    return (
        <Box>
            {/* <Typography sx={{ fontSize: '0.75rem', color: darkMode ? 'var(--lightText)' : "var(--black)" }}>
                {t('takeProfit')} : <b style={{ fontSize: '0.7rem' }}>&gt;{tpValidation}</b>
            </Typography> */}
            <Box sx={{ display: "flex", alignItems: "center", border: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}`, overflow: "hidden" }}>
                <IconButton onClick={() => handleStepChange(false)} sx={{ borderRight: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}`, borderRadius: 0, border: "none" }}>
                    <RemoveIcon fontSize="small" sx={{ fontSize: '1rem' }} />
                </IconButton>
                <TextField type='number' value={takeProfit} onChange={(e) => handleChange(e.target.value)} size="small" inputProps={{ step: (1 / Math.pow(10, symbolData.digits)), style: { textAlign: "center", fontSize: '0.9rem', padding: 0 } }} sx={{ "& .MuiInputBase-input": { textAlign: "center", },"& .MuiOutlinedInput-notchedOutline": { border: "none" }, "& .MuiInputBase-root": { padding: 0 }, color: darkMode ? 'var(--lightText)' : "var(--black)" }} />
                <IconButton onClick={() => handleStepChange(true)} sx={{ borderLeft: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}`, borderRadius: 0, border: "none" }}>
                    <AddIcon fontSize="small" sx={{ fontSize: '1rem' }} />
                </IconButton>
            </Box>
        </Box>
    );
};

export default TPInput;
